import Vue from "vue";

Vue.component("custom-tag-input", {
    props: ["label", "placeholder", "service", "tags", "labelCssClass", "languageId"],
    data() {
        return {
            filteredItems: [],
            dataSource: [],
            selectedTags: [],
            allowNew: false,
            allowDupes: false,
            confirmKeys: window.confirmKeys,
            onPasteSeparator: []
        };
    },
    computed: {
        noData() {
            return window.labels.noData;
        },
        computedValue: {
            get() {
                const tags = this.tags;
                if (!tags || tags.length === 0) return [];
                const val = this.getValues(tags);
               
                return val;
            },
            set(value) {
                if (value) {
                    let texts = [];
                    let ids = [];
                    value.forEach(function (item) {

                        ids.push(item.id);
                    });

                    

                    this.$emit("update:tags", ids);
                }
            }
        }
    },
    mounted() {
        // this.filteredItems = this.dataSource;
        this.getSource(this.service);
    },
    watch: {
        dataSource: function (val) {
            this.filteredItems = val;
        },
        //selectedTags: function (val) {
        //    this.$emit("update:tags", val.map(t => t.id));
        //},
        computedValue: function (val) {
            this.filteredItems = this.dataSource.filter((option) => {
                return !val.id.includes(option.id);
            });
        }
    },
    methods: {
        getFilteredItem: function (text) {
            this.filteredItems = this.dataSource.filter((option) => {
                return  option.displayName.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
            });
        },
        
        getSource: function(source){
            this.$services[source].getForTagInputDropdown({
                language: this.languageId
            })
                .then((data) => {
                    this.dataSource = data.items;
                });
            
        },
        getValues: function (ids) {
            const returnValue = [];
            const items = this.dataSource;

            ids.forEach(function (id) {
                const item = items.filter((t) => { return parseInt(t.id) === id } );
                if (item.length > 0) {
                    returnValue.push(item[0]);
                }
            });

            

            return returnValue;
        }
    },
    template: `
		
					<b-taginput v-model="computedValue"
							:data="filteredItems"
							:allow-duplicates="allowDupes"
							:allow-new="allowNew"
							:open-on-focus="true"
							:placeholder="placeholder"
							autocomplete
							icon="label"
                            ref="refTagInput"
                            :confirm-keys="confirmKeys"
                            :on-paste-separator="onPasteSeparator"
							@typing="getFilteredItem">
						<template slot-scope="props">
							{{ props.option.displayName }}
						</template>
						<template #empty>
							{{ noData }}
						</template>
						<template #selected="props">
							<b-tag v-for="(item, index) in props.tags" :key="index"   maxlength="50" :tabstop="false" rounded closable @close="$refs.refTagInput.removeTag(index, $event)">
								{{ item.displayName }}
							</b-tag>
						</template>
					</b-taginput>	
			
	`
});